<template>
  <div class="device-detail-log-main">
    <!-- 搜索排序 -->
    <div class="device-detail-log-action" v-if="tabLists.length > 0">
      <!-- tab -->
      <ul class="device-detail-tab">
        <li
          v-for="tab in tabLists"
          :key="tab.key"
          :class="activeTabKey === tab.key ? 'active' : ''"
          @click="handleTabs(tab.key)"
        >
          {{ tab.name }}
        </li>
      </ul>

      <!-- 操作日志 -->
      <div class="device-detail-log-action-row1" v-if="activeTabKey === '1'">
        <ul class="device-detail-log-search">
          <li>
            <a-input
              :placeholder="$t('com_form_device_operation_placeholder')"
              v-model="alarmName"
              allowClear
              @pressEnter="getData(true)"
              @change="
                () => {
                  if (!alarmName) {
                    this.getData(true);
                  }
                }
              "
            />
          </li>
          <li>
            <a-range-picker
              @change="
                value => {
                  this.date = value;
                  this.getData(true);
                }
              "
              v-model="date"
            />
          </li>
          <li>
            <a-button type="primary" @click="getData(true)">
              {{ $t('com_btn_lookfor') }}
            </a-button>
            <a-button
              type="default"
              @click="
                () => {
                  this.date = null;
                  this.alarmName = '';
                  this.faultLevel = [];

                  // 重新获取数据
                  this.getData(true);
                }
              "
            >
              {{ $t('com_btn_reset') }}
            </a-button>
          </li>
        </ul>
      </div>

      <!-- 控制日志 -->
      <div class="device-detail-log-action-row1" v-if="activeTabKey === '2'">
        <ul class="device-detail-log-search">
          <li>
            <a-input
              :placeholder="$t('com_form_device_ctrl_placeholder')"
              v-model="alarmNameControl"
              @pressEnter="getData(true)"
              @change="
                () => {
                  if (!alarmNameControl) {
                    this.getData(true);
                  }
                }
              "
              allowClear
            />
          </li>
          <li>
            <a-range-picker
              @change="
                value => {
                  this.dateControl = value;
                  this.getData(true);
                }
              "
              v-model="dateControl"
            />
          </li>
          <li>
            <a-button type="primary" @click="getData(true)">
              {{ $t('com_btn_lookfor') }}
            </a-button>
            <a-button
              type="default"
              @click="
                () => {
                  this.dateControl = null;
                  this.alarmNameControl = '';

                  // 重新获取数据
                  this.getData(true);
                }
              "
            >
              {{ $t('com_btn_reset') }}
            </a-button>
          </li>
        </ul>

        <div class="device-detail-log-btn" v-if="activeTabKey === '2' && hasControlTypes">
          <a-button type="link" @click="handleExpand()">
            <span v-if="!searchExpand">{{ $t('com_btn_expand') }}</span>
            <span v-else>{{ $t('com_btn_collapse') }}</span>
            <a-icon type="up" v-if="searchExpand" />
            <a-icon type="down" v-else />
          </a-button>
        </div>
      </div>

      <!-- 配置项 -->
      <div class="device-detail-log-action-row1" v-if="activeTabKey === '3'">
        <ul class="device-detail-log-search">
          <li>
            <a-input
              :placeholder="$t('com_form_device_param_name_placeholder')"
              v-model="alarmNameParam"
              @pressEnter="getData(true)"
              @change="
                () => {
                  if (!alarmNameParam) {
                    this.getData(true);
                  }
                }
              "
              allowClear
            />
          </li>
          <li>
            <a-range-picker
              @change="
                value => {
                  this.dateParam = value;
                  this.getData(true);
                }
              "
              v-model="dateParam"
            />
          </li>
          <li>
            <a-button type="primary" @click="getData(true)">
              {{ $t('com_btn_lookfor') }}
            </a-button>
            <a-button
              type="default"
              @click="
                () => {
                  this.dateParam = null;
                  this.alarmNameParam = '';
                  this.faultLevelParam = [];

                  // 重新获取数据
                  this.getData(true);
                }
              "
            >
              {{ $t('com_btn_reset') }}
            </a-button>
          </li>
        </ul>
      </div>

      <!-- 配置项 -->
      <div class="device-detail-log-action-row1" v-if="activeTabKey === '4'">
        <ul class="device-detail-log-search">
          <li>
            <a-input
              :placeholder="$t('com_form_device_param_name_placeholder')"
              v-model="alarmNameParamChange"
              @pressEnter="getData(true)"
              @change="
                () => {
                  if (!alarmNameParamChange) {
                    this.getData(true);
                  }
                }
              "
              allowClear
            />
          </li>
          <li>
            <a-range-picker
              @change="
                value => {
                  this.dateParamChange = value;
                  this.getData(true);
                }
              "
              v-model="dateParamChange"
            />
          </li>
          <li>
            <a-button type="primary" @click="getData(true)">
              {{ $t('com_btn_lookfor') }}
            </a-button>
            <a-button
              type="default"
              @click="
                () => {
                  this.dateParamChange = null;
                  this.alarmNameParamChange = '';
                  this.faultLevelParamChange = [];

                  // 重新获取数据
                  this.getData(true);
                }
              "
            >
              {{ $t('com_btn_reset') }}
            </a-button>
          </li>
        </ul>
      </div>

      <!-- 展开的搜索 -->
      <div
        class="device-detail-log-action-row2"
        v-if="searchExpand && activeTabKey === '2' && hasControlTypes"
      >
        <span>{{ $t('com_fault_type') }}</span>
        <a-checkbox-group v-model="controlType" @change="getData">
          <a-checkbox
            :value="item.protoEventType"
            v-for="(item, index) in deviceControlType"
            :key="item.id + '_' + index"
          >
            {{ item.cmdName }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </div>

    <!-- 内容 -->
    <div class="device-detail-log-content">
      <NoAuth
        v-if="
          !(
            AUTH_DEVICE_OPERATOR_HISTORY ||
            AUTH_DEVICE_CTRL_HISTORY ||
            AUTH_DEVICE_CFG_EVENT_HISTORY ||
            AUTH_DEVICE_PARAMS_CHANGE_HISTORY
          )
        "
      />

      <!-- tab：操作日志 -->
      <div
        class="device-detail-tab-conent g-table"
        v-if="activeTabKey === '1' && AUTH_DEVICE_OPERATOR_HISTORY"
      >
        <a-table
          :columns="operationColumns"
          :data-source="operationDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleOperationTable"
          :loading="operationLoading"
        >
          <!-- 执行数据 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              <a-icon
                type="copy"
                data-clipboard-action="copy"
                title="Copy"
                style="color:#ccc"
                :data-clipboard-text="`${text}`"
                :id="`logs_device_operation_event_${record.id}`"
                @click="copyContent(`#logs_device_operation_event_${record.id}`)"
                v-if="text"
              />{{ text }}
            </div>
          </template>

          <!-- 时间 -->
          <template slot="executeTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 属地 -->
          <template slot="Location" slot-scope="text">
            {{ text | location }}
          </template>
        </a-table>
        <div class="pagination">
          <Pagination
            :current.sync="operationPagination.current"
            :total="operationPagination.total"
            :pageSize.sync="operationPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>

      <!-- tab：控制记录 -->
      <div
        class="device-detail-tab-conent g-table"
        v-if="activeTabKey === '2' && AUTH_DEVICE_CTRL_HISTORY"
      >
        <a-table
          :columns="ctrlColumns"
          :data-source="ctrlDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleCtrlTable"
          :loading="ctrlLoading"
        >
          <!-- 类型 -->
          <template slot="operationType" slot-scope="text">
            <span>{{ $t('device_control_log_type')[text] }}</span>
          </template>

          <!-- executeStartTime -->
          <template slot="executeStartTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- executeStartTime -->
          <template slot="executeEndTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <template slot="executeResult" slot-scope="text">
            <!-- 执行结果，0-执行失败，1-执行成功，2-执行超时 -->
            <span v-if="text === 0">{{ $t('com_msg_fail') }}</span>
            <span v-else-if="text === 1">{{ $t('com_msg_success') }}</span>
            <span v-else-if="text === 2">{{ $t('com_msg_timeout') }}</span>
          </template>

          <!-- 执行数据 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              <a-icon
                type="copy"
                data-clipboard-action="copy"
                title="Copy"
                style="color:#ccc"
                :data-clipboard-text="`${text}`"
                :id="`logs_device_command_event_${record.id}`"
                @click="copyContent(`#logs_device_command_event_${record.id}`)"
                v-if="text"
              />{{ text || '' }}
            </div>
          </template>
        </a-table>
        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="ctrlPagination.current"
            :total="ctrlPagination.total"
            :pageSize.sync="ctrlPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>

      <!-- tab：配置记录 -->
      <div
        class="device-detail-tab-conent g-table"
        v-if="activeTabKey === '3' && AUTH_DEVICE_CFG_EVENT_HISTORY"
      >
        <a-table
          :columns="paramColumns"
          :data-source="paramDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleParamTable"
          :loading="paramLoading"
        >
          <!-- 类型 -->
          <template slot="operationType" slot-scope="text">
            <span>{{ $t('device_control_log_type')[text] }}</span>
          </template>

          <!-- 执行数据 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              <a-icon
                type="copy"
                data-clipboard-action="copy"
                title="Copy"
                style="color:#ccc"
                :data-clipboard-text="`${text}`"
                :id="`logs_device_operation_event_${record.id}`"
                @click="copyContent(`#logs_device_operation_event_${record.id}`)"
                v-if="text"
              />{{ text || '' }}
            </div>
          </template>

          <!-- executeStartTime -->
          <template slot="executeStartTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- executeStartTime -->
          <template slot="executeEndTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- operationType -->
          <template slot="executeResult" slot-scope="text">
            <!-- 执行结果，0-执行失败，1-执行成功，2-执行超时 -->
            <span v-if="text === 0">{{ $t('com_msg_fail') }}</span>
            <span v-else-if="text === 1">{{ $t('com_msg_success') }}</span>
            <span v-else-if="text === 2">{{ $t('com_msg_timeout') }}</span>
          </template>
        </a-table>

        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="paramPagination.current"
            :total="paramPagination.total"
            :pageSize.sync="paramPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>

      <!-- tab：配置项变化 -->
      <div
        class="device-detail-tab-conent g-table"
        v-if="activeTabKey === '4' && AUTH_DEVICE_PARAMS_CHANGE_HISTORY"
      >
        <a-table
          :columns="paramChangesColumns"
          :data-source="paramChangesDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleParamChangesTable"
          :loading="paramChangesLoading"
        >
          <!-- 执行数据 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              <a-icon
                type="copy"
                data-clipboard-action="copy"
                title="Copy"
                style="color:#ccc"
                :data-clipboard-text="`${text}`"
                :id="`logs_device_operation_event_${record.id}`"
                @click="copyContent(`#logs_device_operation_event_${record.id}`)"
              />{{ text }}
            </div>
          </template>

          <!-- 时间 -->
          <template slot="executeTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 属地 -->
          <template slot="Location" slot-scope="text">
            {{ text | location }}
          </template>

          <template slot="executeResult" slot-scope="text">
            <!-- 执行结果，true-执行成功，false-执行失败 -->
            <span v-if="text">{{ $t('com_msg_success') }}</span>
            <span v-else>{{ $t('com_msg_fail') }}</span>
          </template>
        </a-table>
        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="paramChangesPagination.current"
            :total="paramChangesPagination.total"
            :pageSize.sync="paramChangesPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  DeviceOperationRecord,
  DeviceControlRecord,
  DeviceParamsRecord,
  DeviceParamsChange,
} from '@/api/device';
import { DeviceModelCtrlList } from '@/api/device';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import { trim } from '@/libs/utils';

export default {
  mixins: [deviceAuth],
  props: {
    // 设备id
    deviceId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),

    // 操作类型
    hasControlTypes() {
      return this.deviceControlType && this.deviceControlType.length > 0;
    },
  },
  data() {
    return {
      trim,
      // 当前tab
      activeTabKey: '1',
      tabLists: [],

      // 展开
      searchExpand: true,

      // 当前数据
      operationDataList: null,

      // 历史数据
      ctrlDataList: null,

      // 参数数据
      paramDataList: null,

      // 参数变更数据
      paramChangesDataList: null,

      // 操作列表
      operationColumns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: this.$t('com_table_type'),
          dataIndex: 'updateType',
          customRender: text => {
            const typeObj = this.$t('com_operationTypes')[text];
            return typeObj ? typeObj.name : '--';
          },
        },

        {
          title: this.$t('logs_table_params_data'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('logs_table_user'),
          dataIndex: 'executeUserName',
          align: 'center',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          align: 'center',
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('logs_table_execute_time'),
          dataIndex: 'executeTime',
          scopedSlots: { customRender: 'executeTime' },
          sorter: true,
        },
      ],

      // 控制列表
      ctrlColumns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },

        {
          title: this.$t('com_table_type'),
          dataIndex: 'operationType',
          scopedSlots: { customRender: 'operationType' },
        },

        {
          title: this.$t('logs_table_params_data'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('logs_table_user'),
          dataIndex: 'executeUserName',
          align: 'center',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          align: 'center',
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('logs_table_execute_start_time'),
          dataIndex: 'executeStartTime',
          scopedSlots: { customRender: 'executeStartTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_execute_end_time'),
          dataIndex: 'executeEndTime',
          scopedSlots: { customRender: 'executeEndTime' },
        },

        {
          title: this.$t('logs_table_execute_end_result'),
          dataIndex: 'executeResult',
          scopedSlots: { customRender: 'executeResult' },
        },
      ],

      // 操作列表
      // id:"主键",
      // operationType:"更新类型，0-新建，1-编辑，2-删除，3-禁用，4-重新启用",
      // executeUser:"操作的用户ID",
      // executeUserName:"操作的用户名",
      // executeStartTime:"执行开始时间，long 类型",
      // executeEndTime:"执行结束时间，long 类型",
      // executeData:"记录执行的操作内容（编辑的内容原始json字符串）",
      // executeResult:"执行结果，0-执行失败，1-执行成功，2-执行超时",
      // hostIp:"获取的用户登录ip地址",
      // location:"该ip所在地"
      paramColumns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },

        {
          title: this.$t('logs_table_params_data'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('logs_table_user'),
          dataIndex: 'executeUser',
          align: 'center',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          align: 'center',
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('logs_table_config_start_time'),
          dataIndex: 'executeStartTime',
          scopedSlots: { customRender: 'executeStartTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_config_end_time'),
          dataIndex: 'executeEndTime',
          scopedSlots: { customRender: 'executeEndTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_execute_end_result'),
          dataIndex: 'executeResult',
          scopedSlots: { customRender: 'executeResult' },
        },
      ],

      // 参数变更列表
      // id:"主键",
      // dataSrc:"设备对应数据字段名",
      // value:"设备对应当前数据值",
      // prevValue:"设备对应上一个数据值",
      // executeUser:"操作的用户ID",
      // executeUserName:"操作的用户",
      // executeTime:"执行时间",
      // hostIp:"获取的用户登录ip地址",
      // location:"该ip所在地",
      paramChangesColumns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: this.$t('device_params_table_name'),
          dataIndex: 'dataSrc',
          scopedSlots: { customRender: 'dataSrc' },
        },

        {
          title: this.$t('device_params_table_prevalue'),
          dataIndex: 'prevValue',
          scopedSlots: { customRender: 'prevValue' },
        },

        {
          title: this.$t('device_params_table_value'),
          dataIndex: 'value',
          scopedSlots: { customRender: 'value' },
        },

        {
          title: this.$t('logs_table_user'),
          dataIndex: 'executeUserName',
          align: 'center',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          align: 'center',
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('logs_table_time'),
          dataIndex: 'executeTime',
          scopedSlots: { customRender: 'executeTime' },
          sorter: true,
          align: 'center',
        },

        // {
        //   title: this.$t('logs_table_execute_end_result'),
        //   dataIndex: 'executeResult',
        //   scopedSlots: { customRender: 'executeResult' },
        // },
      ],

      // 操作日志搜索参数
      date: null,
      deviceName: '',
      alarmName: '',
      faultCode: '',
      operationLoading: false,

      // 控制记录搜索参数
      dateControl: null,
      deviceNameControl: '',
      alarmNameControl: '',
      faultCodeControl: '',
      controlType: [],
      ctrlLoading: false,

      // 配置记录搜索参数
      dateParam: null,
      deviceNameParam: '',
      alarmNameParam: '',
      faultCodeParam: '',
      paramLoading: false,

      // 配置记录搜索参数
      dateParamChange: null,
      deviceNameParamChange: '',
      alarmNameParamChange: '',
      faultCodeParamChange: '',
      paramChangesLoading: false,

      operationPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,

        // 排序字段
        orderField: 3,
        orderType: 1,
      },

      ctrlPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,

        // 排序字段
        orderField: 3,
        orderType: 1,
      },

      paramPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,

        // 排序字段
        orderField: 3,
        orderType: 1,
      },

      paramChangesPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,

        // 排序字段
        orderField: 3,
        orderType: 1,
      },

      // 设备控制类型
      deviceControlType: [],
    };
  },

  created() {
    // 操作日志
    if (this.AUTH_DEVICE_OPERATOR_HISTORY) {
      this.tabLists.push({
        key: '1',
        name: this.$t('device_operation_log_title'),
      });
    }

    // 控制日志
    if (this.AUTH_DEVICE_CTRL_HISTORY) {
      this.tabLists.push({
        key: '2',
        name: this.$t('device_ctrl_log_title'),
      });
    }

    // 配置日志
    if (this.AUTH_DEVICE_CFG_EVENT_HISTORY) {
      this.tabLists.push({
        key: '3',
        name: this.$t('device_params_log_title'),
      });
    }

    // 配置变化日志
    if (this.AUTH_DEVICE_PARAMS_CHANGE_HISTORY) {
      this.tabLists.push({
        key: '4',
        name: this.$t('device_params_change_log_title'),
      });
    }

    // 默认选中第一个
    if (this.tabLists.length > 0) {
      this.activeTabKey = this.tabLists[0].key;
    }

    this.getData();
  },
  methods: {
    handleTabs(key) {
      this.activeTabKey = key;
      this.getData();
    },

    // 获取数据
    getData(search) {
      if (this.activeTabKey === '1') {
        if (search) {
          this.operationPagination.current = 1;
        }
        this.getOperationList();
      } else if (this.activeTabKey === '2') {
        if (search) {
          this.ctrlPagination.current = 1;
        }
        this.getDeviceControlType();
        this.getCtrlList();
      } else if (this.activeTabKey === '3') {
        if (search) {
          this.paramPagination.current = 1;
        }
        this.getParamList();
      } else {
        if (search) {
          this.paramChangesPagination.current = 1;
        }
        this.getParamChangesList();
      }
    },

    // 获取所有设备的控制类型
    getDeviceControlType() {
      DeviceModelCtrlList({
        devId: this.deviceId,
      }).then(res => {
        if (res.code === 0) {
          this.deviceControlType = res.data;
        }
      });
    },

    // 获取当前故障
    getOperationList(params) {
      // devId:"设备ID，必填",
      // keyword:"查询关键字，针对data或执行数据或IP以及地址",
      // date:"执行时间范围查询，默认不传，格式为起始时间-结束时间，例如：1657637444600-1657637554659",
      // orderField:"排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间",
      // orderType:"排序类型, 0为升序，1为倒序",
      // pageNo:"页码",
      // pageSize:"每页数量",
      const _params = {
        devId: this.deviceId,
        pageNo: this.operationPagination.current,
        pageSize: this.operationPagination.pageSize,
        keyword: this.trim(this.alarmName) || undefined,
        date:
          this.date && this.date.length === 2
            ? `${this.date[0].startOf('day').valueOf()}-${this.date[1].endOf('day').valueOf()}`
            : undefined,

        orderField: this.operationPagination.orderField,
        orderType: this.operationPagination.orderType,
        ...(params || {}),
      };

      this.operationLoading = true;
      DeviceOperationRecord(_params)
        .then(res => {
          if (res.code === 0) {
            this.operationDataList = res.data || [];

            this.operationPagination.total = res.totalCount || 0;
          }
        })
        .finally(() => {
          this.operationLoading = false;
        });
    },

    // 获取历史故障
    getCtrlList(params) {
      // devId:"设备ID，必填",
      // keyword:"查询关键字，针对设备名称或SN查询",
      // types:"String类型，控制类型，如果查询全部则不传，如果多个值则英文逗号区分，其值对应设备控制类型。控制类型列表可以复用以前【所有设备模型控制接口】（/dev/basic/model/ctrl/all）",
      // date:"执行时间范围查询，默认不传，格式为起始时间-结束时间，例如：1657637444600-1657637554659",
      // orderField:"排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间",
      // orderType:"排序类型, 0为升序，1为倒序",
      // pageNo:"页码",
      // pageSize:"每页数量",

      const _params = {
        devId: this.deviceId,
        pageNo: this.ctrlPagination.current,
        pageSize: this.ctrlPagination.pageSize,
        keyword: this.trim(this.alarmNameControl) || undefined,

        orderField: this.ctrlPagination.orderField,
        orderType: this.ctrlPagination.orderType,
        ...(params || {}),
      };

      // 日期
      if (this.dateControl && this.dateControl.length === 2) {
        _params.date = `${this.dateControl[0].startOf('day').valueOf()}-${this.dateControl[1]
          .endOf('day')
          .valueOf()}`;
      }

      // 控制类型
      if (this.controlType && this.controlType.length > 0) {
        _params.types = this.controlType.join(',');
      }

      this.ctrlLoading = true;
      DeviceControlRecord(_params)
        .then(res => {
          if (res.code === 0) {
            this.ctrlDataList = res.data || [];

            this.ctrlPagination.total = res.totalCount || 0;
          }
        })
        .finally(() => {
          this.ctrlLoading = false;
        });
    },

    // 获取配置日志
    getParamList(params) {
      // devId:"设备ID，必填",
      // keyword:"查询关键字，针对设备名称或SN查询",
      // date:"执行时间范围查询，默认不传，格式为起始时间-结束时间，例如：1657637444600-1657637554659",
      // orderField:"排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间",
      // orderType:"排序类型, 0为升序，1为倒序",
      // pageNo:"页码",
      // pageSize:"每页数量",

      const _params = {
        devId: this.deviceId,
        pageNo: this.paramPagination.current,
        pageSize: this.paramPagination.pageSize,
        keyword: this.trim(this.alarmNameParam) || undefined,
        date:
          this.dateParam && this.dateParam.length === 2
            ? `${this.dateParam[0].startOf('day').valueOf()}-${this.dateParam[1]
                .endOf('day')
                .valueOf()}`
            : undefined,
        orderField: this.paramPagination.orderField,
        orderType: this.paramPagination.orderType,
        ...(params || {}),
      };

      this.paramLoading = true;
      DeviceParamsRecord(_params)
        .then(res => {
          if (res.code === 0) {
            this.paramDataList = res.data || [];

            this.paramPagination.total = res.totalCount || 0;
          }
        })
        .finally(() => {
          this.paramLoading = false;
        });
    },

    // 获取配置变化项日志
    getParamChangesList(params) {
      // devId:"设备ID，必填",
      // keyword:"查询关键字，针对设备名称或SN查询",
      // date:"执行时间范围查询，默认不传，格式为起始时间-结束时间，例如：1657637444600-1657637554659",
      // orderField:"排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间",
      // orderType:"排序类型, 0为升序，1为倒序",
      // pageNo:"页码",
      // pageSize:"每页数量",

      const _params = {
        devId: this.deviceId,
        pageNo: this.paramChangesPagination.current,
        pageSize: this.paramChangesPagination.pageSize,
        levels: this.faultLevelParamChange ? this.faultLevelParamChange.join(',') : undefined,
        keyword: this.trim(this.alarmNameParamChange) || undefined,
        date:
          this.dateParamChange && this.dateParamChange.length === 2
            ? `${this.dateParamChange[0].startOf('day').valueOf()}-${this.dateParamChange[1]
                .endOf('day')
                .valueOf()}`
            : undefined,
        orderField: this.paramChangesPagination.orderField,
        orderType: this.paramChangesPagination.orderType,
        ...(params || {}),
      };

      this.paramChangesLoading = true;
      DeviceParamsChange(_params)
        .then(res => {
          if (res.code === 0) {
            this.paramChangesDataList = res.data || [];

            this.paramChangesPagination.total = res.totalCount || 0;
          }
        })
        .finally(() => {
          this.paramChangesLoading = false;
        });
    },

    // 展开
    handleExpand() {
      this.searchExpand = !this.searchExpand;
    },

    // 分页
    currentPageChange(page) {
      if (this.activeTabKey === '1') {
        this.operationPagination.current = page;
      } else if (this.activeTabKey === '2') {
        this.ctrlPagination.current = page;
      } else if (this.activeTabKey === '3') {
        this.paramPagination.current = page;
      } else {
        this.paramChangesPagination.current = page;
      }

      // 重新获取数据
      this.getData();
    },

    handleOperationTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;

      if (field === 'id') {
        orderField = 0;
      } else if (field === 'updateType') {
        orderField = 1;
      } else if (field === 'executeUser') {
        orderField = 2;
      } else if (field === 'executeTime') {
        orderField = 3;
      }
      orderType = order === 'ascend' ? 0 : 1;
      this.operationPagination.orderField = orderField;
      this.operationPagination.orderType = orderType;

      this.getOperationList({
        orderField,
        orderType,
      });
    },

    handleCtrlTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;

      if (field === 'id') {
        orderField = 0;
      } else if (field === 'updateType') {
        orderField = 1;
      } else if (field === 'executeUser') {
        orderField = 2;
      } else if (field === 'executeStartTime' || field === 'executeEndTime') {
        orderField = 3;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.ctrlPagination.orderField = orderField;
      this.ctrlPagination.orderType = orderType;

      this.getDeviceControlType();
      this.getCtrlList({
        orderField,
        orderType,
      });
    },

    handleParamTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;
      console.log('field', field);

      if (field === 'id') {
        orderField = 0;
      } else if (field === 'operationType') {
        orderField = 1;
      } else if (field === 'executeUser') {
        orderField = 2;
      } else if (field === 'executeStartTime' || field === 'executeEndTime') {
        orderField = 3;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.paramPagination.orderField = orderField;
      this.paramPagination.orderType = orderType;

      this.getParamList({
        orderField,
        orderType,
      });
    },

    handleParamChangesTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;

      if (field === 'id') {
        orderField = 0;
      } else if (field === 'executeTime') {
        orderField = 3;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.paramChangesPagination.orderField = orderField;
      this.paramChangesPagination.orderType = orderType;

      this.getParamChangesList({
        orderField,
        orderType,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.device-detail-log-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  background: @g-layout-background;

  // 搜索
  .device-detail-log-action {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    margin-bottom: 16px;

    .device-detail-tab {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
      gap: 24px;
      margin-bottom: 16px;
      li {
        color: rgba(0, 0, 0, 0.88);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        display: flex;

        &.active {
          color: @primary-color;
          font-weight: 600;
          position: relative;

          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: @primary-color;
            position: absolute;
            bottom: -4px;
            left: 0;
          }
        }
      }
    }

    .device-detail-log-action-row1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      // 搜索排序
      ul.device-detail-log-search {
        display: flex;
        margin: 0;
        padding: 0;
        list-style: none;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        li {
          display: flex;
          align-items: center;
          width: 296px;
          gap: 12px;
          &:last-child {
            width: auto;
          }
        }
      }

      // 排序
      .device-detail-log-btn {
        display: flex;
        align-items: center;

        button {
          margin-left: 12px;
        }
      }
    }

    .device-detail-log-action-row2 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 24px 0 0 0;
      span {
        color: rgba(0, 0, 0, 0.88);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        margin-right: 16px;
      }
    }
  }

  // 内容
  .device-detail-log-content {
    background: #fff;
    box-shadow: 0 -12px 0 0 @g-layout-background;
    border-radius: 12px;
    flex: 1;
    padding: 24px;
    display: flex;

    .device-detail-tab-conent {
      width: 100%;
    }
  }
}
</style>
